{"version":"26.10.28-local-solo","id":"at.softline.lagerhaus.eferding.softline","name":"Lagerhaus Eferding Softline"}